module.exports = __webpack_public_path__ + "static/media/color-logo-full.2fe6cd4a.svg";